// Shared UI Library Components
import { CustomIcon, EIconName } from "@ppmcore/seven-ppm-core-shared-components-react";

export const CBusinessProfileMenuList = [
  {
    label: 'Business Information',
    path: 'business-profile',
    icon: <CustomIcon name={ EIconName.Info }/>,
    activeIcon: <CustomIcon name={ EIconName.InfoFill }/>
  },
  {
    label: 'Payment Details',
    path: 'business-profile/payment-details',
    icon: <CustomIcon name={ EIconName.Wallet }/>,
    activeIcon: <CustomIcon name={ EIconName.Wallet_fill }/>
  },
  {
    label: 'Billing',
    path: 'business-profile/billing',
    icon: <CustomIcon name={ EIconName.Subscription }/>,
    activeIcon: <CustomIcon name={ EIconName.SubscriptionFill }/>
  },
  {
    label: 'Theme & Widget',
    path: 'business-profile/theme-and-widget',
    icon: <CustomIcon name={ EIconName.ThemeSettings }/>,
    activeIcon: <CustomIcon name={ EIconName.ThemeSettingsFill }/>
  },
  // TODO next release
  // {
  //   label: 'Logo Settings',
  //   path: 'business-profile/logo-settings',
  //   icon: <CustomIcon name={ EIconName.LogoSettings }/>,
  //   activeIcon: <CustomIcon name={ EIconName.LogoSettingsFill }/>
  // },
  // {
  //   label: 'Illustrations Settings',
  //   path: 'business-profile/illustrations-settings',
  //   icon: <CustomIcon name={ EIconName.Illustration }/>,
  //   activeIcon: <CustomIcon name={ EIconName.IllustrationFill }/>
  // },
  // {
  //   label: 'Widget Settings',
  //   path: 'business-profile/widget-settings',
  //   icon: <CustomIcon name={ EIconName.Widget }/>,
  //   activeIcon: <CustomIcon name={ EIconName.WidgetFill }/>
  // },

  {
    label: 'Consultant Attributes',
    path: 'business-profile/counsellor-attributes',
    icon: <CustomIcon name={ EIconName.CounsellorsSettings }/>,
    activeIcon: <CustomIcon name={ EIconName.CounsellorsSettingsFill }/>
  },
  {
    label: 'Permission Settings',
    path: 'business-profile/permission-settings',
    icon: <CustomIcon name={ EIconName.PermissionSettingsFill }/>,
    activeIcon: <CustomIcon name={ EIconName.PermissionSettingsFill }/>
  },
  {
    label: 'Consultations Settings',
    path: 'business-profile/consultations-settings',
    icon: <CustomIcon name={ EIconName.Time }/>,
    activeIcon: <CustomIcon name={ EIconName.TimeFill }/>
  },
  {
    label: 'Terms of Service',
    path: 'business-profile/terms-of-service',
    icon: <CustomIcon name={ EIconName.TermsOfService }/>,
    activeIcon: <CustomIcon name={ EIconName.TermsOfServiceFill }/>
  },
  {
    label: 'Privacy Policy',
    path: 'business-profile/privacy-policy',
    icon: <CustomIcon name={ EIconName.PrivacyPolicy }/>,
    activeIcon: <CustomIcon name={ EIconName.PrivacyPolicyFill }/>
  },
];
